export class VendorPerformanceDistinctFsc {
  PREV_REMV_FSC: string;
  PREV_FSC_COMPANY_NAME: string;
}
